import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import Viser from 'viser-vue'
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(Viser);
